import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button, Row, Col, Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { getAdditionalFields, getSubAdditionalFields, getSubSubAdditionalFields ,getBookingCategories,getBookingSubCategories,getBookingSubSubCategories,getTicketInfoByPlaceId, getTicketType, getTicketSubType, getTicketSubSubType} from "../../redux/actions/indexActions";
import AdditionalFormFields from "./AdditionalFormFields";
const TicketForm = ({ ticketSubType, placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { additionalFieldsList, subAdditionalFieldsList, bookingCategoriesList, bookingSubCategoriesList ,bookingCategories ,bookingSubCategories ,bookingSubSubCategories ,ticketFormAdditionalFields ,TicketTypeList, TicketSubTypeList ,TicketSubSubTypeList ,editBookingForm} } = useSelector((state) => state);
    const [singleDayBooking, setSingleDayBooking] = useState(false);
    // const [bookingCategories, setBookingCategories] = useState([]);
    // const [bookingSubCategories, setBookingSubCategories] = useState([]);
    // const [bookingSubSubCategories, setBookingSubSubCategories] = useState([]);
    const [errors, setErrors] = useState({});
    const [addFormType, setAddFormType] = useState("");
    const [addFields, setAddFields] = useState({
        booking_category_id:"",
        booking_sub_category_id:"",
        field_name:"",
        field_type:"",
        file:"",
        link:"",
        name_attr:"",
        is_upload_doc: 0,
        place_id:placeId,
    });
    const [ticketForm, setTicketForm] = useState({
        form_type:'Individual',
        is_single_day_booking:0,
        durationEnabled:0,
        individualFormName:'',
        additionalFieldsEnabled:0,
        additionalField: 0,
        subAdditionalField: 0,
        subSubAdditionalField: 0,
        additionalFieldType: "",
        additional_field_id: "",
        sub_additional_field_id: "",
        is_additional_document: 0,
        groupBookingEnabled: 0,
        is_group_booking_category: 0,
        is_group_booking_sub_category: 0,
        is_group_booking_sub_sub_category: 0,
        booking_category_id: "",
        booking_sub_category_id: "",
        booking_sub_sub_category_id: "",
        is_group_booking_document: 0,
        is_additional_fields: 0,
        isRange: 0,
        isDuration: 0,
        isFixedDays: 0,
        add_field_type:"",
        add_field_name: "",
        durations:[],
        fixedDays:[],
        rangeDays:[],
        place_id: placeId,
    });
    const [ticketTypes, setTicketTypes] = useState({
        ticket_type_id:0,
        ticket_sub_type_id:0,
        ticket_sub_sub_type_id:0,
    });

    useEffect(()=>{
        dispatch(getBookingCategories(auth.token,placeId));
        dispatch(getTicketType(auth.token, placeId));
    },[auth.token,placeId]);

    useEffect(()=>{
        const data = editBookingForm;
        if (data && Object.keys(data).length > 0) {
            dispatch(getTicketSubType(auth.token, data?.ticket_type_id));
            dispatch(getTicketSubSubType(auth.token, data?.ticket_sub_type_id));
            setTicketTypes((prev) => ({
                ...prev,
                ticket_type_id:data?.ticket_type_id,
                ticket_sub_type_id:data?.ticket_sub_type_id,
                ticket_sub_sub_type_id:data?.ticket_sub_sub_type_id,
            }))
            
            // Safely handle arrays with proper checks
            const rangeDaysData = Array.isArray(data?.rangeDays) ? data.rangeDays : [];
            const fixedDaysData = Array.isArray(data?.fixedDays) ? data.fixedDays : [];
            const durationsData = Array.isArray(data?.durations) ? data.durations : [];
            
            setRangeDays(rangeDaysData);
            setFixedDays(fixedDaysData);
            setDurationsFields(durationsData);
            
            setTicketForm((prev) => ({
                ...prev,
                form_type:'Individual',
                is_single_day_booking:data?.is_single_day_booking,
                individualFormName:data?.individual_form_name,
                isRange: rangeDaysData.length > 0 ? 1 : 0,
                isDuration: durationsData.length > 0 ? 1 : 0,
                isFixedDays: fixedDaysData.length > 0 ? 1 : 0,
                durations: durationsData,
                fixedDays: fixedDaysData,
                rangeDays: rangeDaysData,
                durationEnabled:data?.enable_duration,
                place_id: placeId,
            }));
        }
    },[editBookingForm])



    const [CommonForm, setCommonForm] = useState(false);
    const [individualForm, setIndividualForm] = useState(false);


    const [durationEnabled, setDurationEnabled] = useState(false);
    const [duration, setDuration] = useState({
        from: '',
        to: '',
        days: [],
        dayCount: 0,
    });
    const [additionalFieldsEnabled, setAdditionalFieldsEnabled] = useState(false);
    const [additionalFields, setAdditionalFields] = useState([]);
    const [newAdditionalField, setNewAdditionalField] = useState({ type: "", name: "" });
    const [groupBookingEnabled, setGroupBookingEnabled] = useState(false);
    const [newBookingCategory, setNewBookingCategory] = useState({
        category: "",
        subCategory: "",
        subSubCategory: "",
    });
    const [newIndividualForm, setNewIndividualForm] = useState({ type: "", name: "" });
    const [attachDocumentEnabled, setAttachDocumentEnabled] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [newDocument, setNewDocument] = useState({ title: "", file: null, link: "" });
    const calculateDayCount = (from, to) => {
        if (!from && !to) return 0;
        const start = new Date(from);
        const end = new Date(to);
        const timeDiff = end - start;
        const dayCount = timeDiff / (1000 * 3600 * 24);
        // return Math.max(dayCount, 0);
        return Math.max(dayCount + 1, 0);
    };

    const handleTicketTypes = (e) => {
        const { name,value } = e.target;
        setTicketTypes((prev) => ({
            ...prev,
            [name] : value,
        }));
        if(name == 'ticket_type_id'){
            dispatch(getTicketSubType(auth.token, value));
        }
        if(name == 'ticket_sub_type_id'){
            dispatch(getTicketSubSubType(auth.token, value));
        }
    };

    const addAdditionalField = () => {
        if (newAdditionalField.type && newAdditionalField.name) {
            setAdditionalFields([...additionalFields, newAdditionalField]);
            setNewAdditionalField({ type: "", name: "" });
        }
    };

    const removeAdditionalField = (index) => {
        setAdditionalFields(additionalFields.filter((_, i) => i !== index));
    };

    const addBookingCategory = () => {
        if (newBookingCategory.category) {
            // setBookingCategories([...bookingCategories, newBookingCategory]);
            setNewBookingCategory({ category: "", subCategory: "", subSubCategory: "" });
        }
    };

    const removeBookingCategory = (index) => {
        // setBookingCategories(bookingCategories.filter((_, i) => i !== index));
    };

    const addDocument = () => {
        if (newDocument.title && (newDocument.file || newDocument.link)) {
            setDocuments([...documents, newDocument]);
            setNewDocument({ title: "", file: null, link: "" });
        }
    };

    const removeDocument = (index) => {
        setDocuments(documents.filter((_, i) => i !== index));
    };

    const handleSubmitold = () => {
        const formData = {
            singleDayBooking,
            duration,
            additionalFields,
            groupBookingEnabled,
            bookingCategories,
            attachDocumentEnabled,
            documents,
        };
        console.log("Form Data:", formData);
    };
    const [durations, setDurationsFields] = useState([{ fromDate: '', toDate: '', days: 0 }]);

    const addDurations = () => {
        setDurationsFields((durations) => [...durations, { fromDate: "", toDate: "", days: 0 }]);
    };

    const removeDurations = (index) => {
        if (durations.length > 1) {
            setDurationsFields((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleDurationChange = (index, field, value) => {
        setDurationsFields((prev) => {
            // Step 1: Clone and update the new item
            const newDurations = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
    
            const updatedItem = newDurations[index];
    
            // Step 2: If both dates are filled, calculate days and check for duplicates
            if (updatedItem.fromDate !== '' && updatedItem.toDate !== '') {
                const isDuplicate = newDurations.some((item, i) =>
                    i !== index &&
                    item.fromDate === updatedItem.fromDate &&
                    item.toDate === updatedItem.toDate
                );
    
                if (isDuplicate) {
                    toast.error("This date range already exists.");
                    return prev; // Discard change
                }
    
                const newDays = calculateDayCount(updatedItem.fromDate, updatedItem.toDate);
                newDurations[index] = { ...updatedItem, days: newDays };
            }
    
            return newDurations;
        });
    };
    
    // Additional Fields
    const [additionalFieldInput, setAdditionalFieldInput] = useState([{ field_type_id: '', name: '' }]);

    const addAdditionalFieldInput = () => {
        setAdditionalFieldInput((prev) => [...prev, { field_type_id: "", name: "" }]);
    };

    const removeAdditionalFieldInput = (index) => {
        if (additionalFieldInput.length > 1) {
            setAdditionalFieldInput((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleAdditionalInputChange = (index, field, value, type) => {
        setAdditionalFieldInput((prev) => {
            const newFields = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            const updatedItem = newFields[index];
            if (updatedItem.name != '') {
                newFields[index] = { ...updatedItem, field_type_id: ticketForm.additionalFieldType, place_id: placeId, type: type };
            }
            return newFields;
        });
    };

    const handleAdditionalSubmit = () => {
        const formData = new FormData();
        additionalFieldInput.forEach((item, index) => {
            if (item.name !== "" && item.field_type_id !== "") {
                formData.append(`additional_fields[${index}][field_type_id]`, item.field_type_id);
                formData.append(`additional_fields[${index}][name]`, item.name);
                formData.append(`additional_fields[${index}][place_id]`, item.place_id);
                formData.append(`additional_fields[${index}][type]`, item.type);
            }
        });
        axios.post(`/api/admin/v1/add-additional-field`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch(getAdditionalFields(auth.token, placeId, ticketForm.additionalFieldType));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    // Sub Additional Fields

    const [subAdditionalInput, setSubAdditionalInput] = useState([{ field_type_id: '', additional_field_id: '', name: '' }]);

    const addSubAdditionalFieldInput = () => {
        setSubAdditionalInput((prev) => [...prev, { field_type_id: "", additional_field_id: "", name: "" }]);
    };

    const removeSubAdditionalFieldInput = (index) => {
        if (subAdditionalInput.length > 1) {
            setSubAdditionalInput((prev) => prev.filter((_, i) => i !== index));
        }
    };


    const handleSubAdditionalInputChange = (index, field, value, type) => {
        setSubAdditionalInput((prev) => {
            const newFields = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            const updatedItem = newFields[index];
            if (updatedItem.name != '') {
                newFields[index] = {
                    ...updatedItem,
                    field_type_id: ticketForm.additionalFieldType,
                    additional_field_id: ticketForm.additional_field_id,
                    place_id: placeId,
                    type: type,
                };
            }
            return newFields;
        });
    };

    const handleSubAdditionalSubmit = () => {
        const formData = new FormData();
        subAdditionalInput.forEach((item, index) => {
            if (item.name !== "" && item.additional_field_id !== "") {
                formData.append(`sub_additional_fields[${index}][field_type_id]`, item.field_type_id);
                formData.append(`sub_additional_fields[${index}][additional_field_id]`, item.additional_field_id);
                formData.append(`sub_additional_fields[${index}][name]`, item.name);
                formData.append(`sub_additional_fields[${index}][place_id]`, item.place_id);
                formData.append(`sub_additional_fields[${index}][type]`, item.type);
            }
        });
        axios.post(`/api/admin/v1/add-sub-additional-field`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch(getSubAdditionalFields(auth.token, placeId, ticketForm.additional_field_id));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    // Sub Sub Additional Fields
    const [subSubAdditionalInput, setSubSubAdditionalInput] = useState([{ field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: '' }]);

    const addSubSubAdditionalFieldInput = () => {
        setSubSubAdditionalInput((prev) => [...prev, { field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: "" }]);
    };

    const removeSubSubAdditionalFieldInput = (index) => {
        if (subSubAdditionalInput.length > 1) {
            setSubSubAdditionalInput((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleSubSubAdditionalInputChange = (index, field, value, type) => {
        setSubSubAdditionalInput((prev) => {
            const newFields = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            const updatedItem = newFields[index];
            if (updatedItem.name != '') {
                newFields[index] = {
                    ...updatedItem,
                    field_type_id: ticketForm.additionalFieldType,
                    additional_field_id: ticketForm.additional_field_id,
                    sub_additional_field_id: ticketForm.sub_additional_field_id,
                    place_id: placeId,
                    type: type,
                };
            }
            return newFields;
        });
    };

    const handleSubSubAdditionalSubmit = () => {
        const formData = new FormData();
        subSubAdditionalInput.forEach((item, index) => {
            if (item.name !== "" && item.sub_additional_field_id !== "") {
                formData.append(`sub_sub_additional_fields[${index}][field_type_id]`, item.field_type_id);
                formData.append(`sub_sub_additional_fields[${index}][additional_field_id]`, item.additional_field_id);
                formData.append(`sub_sub_additional_fields[${index}][sub_additional_field_id]`, item.sub_additional_field_id);
                formData.append(`sub_sub_additional_fields[${index}][name]`, item.name);
                formData.append(`sub_sub_additional_fields[${index}][place_id]`, item.place_id);
                formData.append(`sub_sub_additional_fields[${index}][type]`, item.type);
            }
        });
        axios.post(`/api/admin/v1/add-sub-sub-additional-field`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch(getSubAdditionalFields(auth.token, placeId, ticketForm.additional_field_id));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };


        // Booking Category
        const [bookingCategory, setBookingCategory] = useState([{ name: '' }]);

        const addBookingCategoryInput = () => {
            setBookingCategory((prev) => [...prev, { name: "" }]);
        };
    
        const removeBookingCategoryInput = (index) => {
            if (bookingCategory.length > 1) {
                setBookingCategory((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleBookingCategoryChange = (index, field, value, type) => {
            setBookingCategory((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                const updatedItem = newFields[index];
                if (updatedItem.name != '') {
                    newFields[index] = { ...updatedItem,};
                }
                return newFields;
            });
        };

        useEffect(()=>{
            console.log('bookingCategory>>',bookingCategory);
        },[bookingCategory])
    
        const handleBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Please select the category');
            }
            const formData = new FormData();
            bookingCategory.forEach((item, index) => {
                if (item.name !== "" && item.field_type_id !== "") {
                    formData.append(`booking_category[${index}][category_id]`, 0);
                    formData.append(`booking_category[${index}][name]`, item.name);
                    formData.append(`booking_category[${index}][place_id]`, placeId);
                    formData.append(`booking_category[${index}][type]`, addFormType);
                }
            });
            axios.post(`/api/admin/v1/add-groupBooking-category`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                dispatch({
                    type: "GET_BOOKING_CATEGORIES_FULFILLED",
                    payload: res?.data,
                });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };
    
        // Sub Booking Category
    
        const [subBookingCategory, setSubBookingCategory] = useState([{ field_type_id: '', additional_field_id: '', name: '' }]);
    
        const addSubBookingCategoryInput = () => {
            setSubBookingCategory((prev) => [...prev, { field_type_id: "", additional_field_id: "", name: "" }]);
        };
    
        const removeSubBookingCategoryInput = (index) => {
            if (subBookingCategory.length > 1) {
                setSubBookingCategory((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleSubBookingCategoryChange = (index, field, value, type) => {
            setSubBookingCategory((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                return newFields;
            });
        };
    
        const handleSubBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Please select the category');
            }
            if(!ticketForm.booking_category_id){
                return toast.error('Please select the Booking category');
            }
            const formData = new FormData();
            subBookingCategory.forEach((item, index) => {
                if(!item.name){
                    return toast.error('Booking Subcategory name is required!');
                }
                formData.append(`booking_category[${index}][name]`, item.name);
                formData.append(`booking_category[${index}][place_id]`, placeId);
                formData.append(`booking_category[${index}][category_id]`, ticketForm.booking_category_id);
                formData.append(`booking_category[${index}][type]`, addFormType);
            });
            axios.post(`/api/admin/v1/add-groupBooking-subCategory`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                dispatch({
                    type: "GET_BOOKING_SUB_CATEGORIES_FULFILLED",
                    payload: res?.data,
                });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };
    
        // Sub Sub Booking Category
        const [subSubBookingCategoryInput, setSubSubBookingCategoryInput] = useState([{ field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: '' }]);
    
        const addSubSubBookingCategory = () => {
            setSubSubBookingCategoryInput((prev) => [...prev, { field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: "" }]);
        };
    
        const removeSubSubBookingCategory = (index) => {
            if (subSubBookingCategoryInput.length > 1) {
                setSubSubBookingCategoryInput((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleSubSubBookingCategoryChange = (index, field, value, type) => {
            setSubSubBookingCategoryInput((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                return newFields;
            });
        };
    
        const handleSubSubBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Category field is required!');
            }
            if(!ticketForm.booking_category_id){
                return toast.error('Booking category field is required!');
            }
            if(!ticketForm.booking_sub_category_id){
                return toast.error('Booking Sub category field is required!');
            }
            const formData = new FormData();
            subSubBookingCategoryInput.forEach((item, index) => {
                if(!item.name){
                    return toast.error('Booking Sub Sub category name is required!');
                }
                formData.append(`booking_category[${index}][category_id]`, ticketForm.booking_category_id);
                formData.append(`booking_category[${index}][sub_category_id]`, ticketForm.booking_sub_category_id);
                formData.append(`booking_category[${index}][name]`, item.name);
                formData.append(`booking_category[${index}][place_id]`,placeId);
                formData.append(`booking_category[${index}][type]`, addFormType);
            });
            axios.post(`/api/admin/v1/add-groupBooking-subSubCategory`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                dispatch({
                    type: "GET_BOOKING_SUB_SUB_CATEGORIES_FULFILLED",
                    payload: res?.data,
                });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };

    const [attackDocuments, setAttackDocuments] = useState([{ name: '', file: '', link: '' }]);

    const addAttackDocuments = () => {
        setAttackDocuments((prev) => [...prev, { name: '', file: '', link: '' }]);
    };

    const removeAttackDocuments = (index) => {
        if (attackDocuments.length > 1) {
            setAttackDocuments((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleAttackDocumentsChanges = (index, field, value) => {
        setAttackDocuments((prev) => {
            const newFields = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            return newFields;
        });
    };

    const [bookingAttackDocuments, setBookingAttackDocuments] = useState([{ name: '', file: '', link: '' }]);

    const addBookingAttackDocuments = () => {
        setBookingAttackDocuments((prev) => [...prev, { name: '', file: '', link: '' }]);
    };

    const removeBookingAttackDocuments = (index) => {
        if (attackDocuments.length > 1) {
            setBookingAttackDocuments((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleBookingAttackDocumentsChanges = (index, field, value) => {
        setBookingAttackDocuments((prev) => {
            const newFields = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            return newFields;
        });
    };

    useEffect(() => {
        dispatch(getAdditionalFields(auth.token, placeId, ticketForm.additionalFieldType));
    }, [ticketForm.additionalFieldType]);

    useEffect(() => {
        dispatch(getSubAdditionalFields(auth.token, placeId, ticketForm.additional_field_id));
    }, [ticketForm.additional_field_id]);

    useEffect(() => {
        console.log('durations>>', durations);
    }, [durations, additionalFieldInput, subAdditionalInput, subSubAdditionalInput, attackDocuments]);

    const handleSubmit = () => {
        if(ticketForm.durationEnabled){
            const hasEmptyDate = durations.some(item => !item.fromDate || !item.toDate);
            if (hasEmptyDate) {
                toast.error("All durations must have both From Date and To Date.");
                return;
            }
        }

        const data = {
            ...ticketForm,
            ...ticketTypes,
        };
        axios.post(`/api/admin/v1/add-update-ticket-form`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    const convertToSnakeCase = (str) => {
        return str
            .toLowerCase()                // Convert to lowercase
            .replace(/\s+/g, "_")         // Replace spaces with underscores
            .replace(/[^a-z0-9_]/g, "");  // Remove special characters (if any)
    };

    const handleAddFieldChange = (e) => {
        const { name, value, type, files } = e.target;
        setAddFields((prev) => ({
            ...prev,
            [name]: type === "file" ? files[0] : value,
            name_attr: name === "field_name" ? convertToSnakeCase(value) : prev.name_attr,
        }));
        if (name === "booking_category_id") {
            dispatch(getBookingSubCategories(auth.token, placeId, value));
        } else if (name === "booking_sub_category_id") {
            dispatch(getBookingSubSubCategories(auth.token, placeId, addFields.booking_category_id, value));
        }
    };

    const addAllAdditionalField = () => {
        axios.post(`/api/admin/v1/add-ticketform-additional-fields`, addFields, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            setAddFields({
                booking_category_id: "",
                booking_sub_category_id: "",
                field_name: "",
                field_type: "",
                file: "",
                link: "",
                is_upload_doc: 0,
                place_id:placeId,
            });
            dispatch(getTicketInfoByPlaceId(auth?.token,placeId));
            // dispatch({
            //     type: "GET_BOOKING_SUB_SUB_CATEGORIES_FULFILLED",
            //     payload: res?.data,
            // });
        }).catch((err) => {
            toast.error(err.response.data);
            setErrors(err.response.data);
        });
    };
 
  

    const [fixedDays, setFixedDays] = useState([]);
    const [daysValue, setDaysValue] = useState("");
    const removeFixedDays = (index) => {
        setFixedDays((prev) => prev.filter((_, i) => i !== index));
    };
    const addFixedDays = () => {
        const isDuplicate = fixedDays.some(item => item.days === daysValue);
        if (isDuplicate) {
          toast.error("This day range already exists.");
          return;
        }
        if (daysValue == "" || daysValue == 0) {
          toast.error("This input value must be greater then 0 day.");
          return;
        }
        setFixedDays(prev => [...prev, { days: daysValue }]);
        setDaysValue("");
    };

    const [rangeDays, setRangeDays] = useState([]);
    const [rangeValue, setRangeValue] = useState({min:"",max:""});
    const removeRangeDays = (index) => {
        setRangeDays((prev) => prev.filter((_, i) => i !== index));
    };
    const addRangeDays = () => {
        const isDuplicate = rangeDays.some(item => (item.min == rangeValue.min) && (item.max == rangeValue.max) );
        if (isDuplicate) {
          toast.error("This day range already exists.");
          return;
        }
        if (rangeValue.min == "" || rangeValue.min == 0) {
          toast.error("This min input value must be greater then 0 day.");
          return;
        }
        if (rangeValue.max == "" || rangeValue.max == 0) {
          toast.error("This max input value must be greater then 0 day.");
          return;
        }
        if (rangeValue.min ==  rangeValue.max) {
          toast.error("This min and max input value must not be same.");
          return;
        }
        if (rangeValue.min >  rangeValue.max) {
          toast.error("This min day must not be greater then the max day.");
          return;
        }
        setRangeDays(prev => [...prev, rangeValue]);
        setRangeValue({min:"",max:""});
    };

    useEffect(() => {
        setTicketForm((prev) => ({
            ...prev,
            durations: durations,
            fixedDays: fixedDays,
            rangeDays: rangeDays,
        }));
    }, [durations,fixedDays,rangeDays]);

    useEffect(()=>{
        console.log('ticketForm===>>', ticketForm);
    },[ticketForm])

    return (
        <div className="container bg-white p-4 rounded shadow-lg">
            <h4 className="mb-1 text-center">Ticket Form</h4>
            <Row>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_type_id"
                            value={ticketTypes.ticket_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.ticket_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_type_id}</span>
                    </div>
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_type_id"
                            value={ticketTypes.ticket_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_type_id}</span>
                    </div> 
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_sub_type_id"
                            value={ticketTypes.ticket_sub_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketSubSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_sub_type_id}</span>
                    </div> 
                </Col>
            </Row>
            <Row>
                {/* <Col md={6}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="radio" 
                                checked={ticketForm.form_type === 'Common'} 
                                onChange={(e) => setTicketForm((prev) => ({
                                    ...prev,
                                    form_type: e.target.checked ? 'Common' : 'Individual',
                                }))} 
                                className="me-2" />
                            Common Form
                        </Label>
                    </FormGroup>
                </Col> */}
                <Col md={6}>
                    {/* <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="radio" 
                            checked={ticketForm.form_type === 'Individual'}  
                            onChange={(e) => setTicketForm((prev)=>({
                                ...prev,
                                form_type:e.target.checked ? 'Individual':'Common',
                            }))}
                             className="me-2" />
                            Individual Form
                        </Label>
                    </FormGroup> */}
                    {/* {ticketForm.form_type == 'Individual' && ( */}
                        <div className="d-flex align-items-center mb-3">
                            <Input type="text" placeholder="Form Name" value={ticketForm.individualFormName} onChange={(e) => setTicketForm({ ...ticketForm, individualFormName: e.target.value })} className="me-2" />
                        </div>
                    {/* )} */}
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={ticketForm.is_single_day_booking == 1} 
                            onChange={(e) => setTicketForm((prev)=>({
                                ...prev,
                                is_single_day_booking: e.target.checked ? 1 : 0,
                            }))} 
                            className="me-2" />
                            Single Day Booking
                        </Label>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                             checked={ticketForm.durationEnabled === 1} 
                            onChange={(e) => setTicketForm({...ticketForm,durationEnabled:e.target.checked ? 1 : 0})} 
                            className="me-2" />
                            Enable Duration
                        </Label>
                    </FormGroup>
                </Col>
                {ticketForm.durationEnabled === 1 ? (
                    <>
                    <Col md={4}>
                        <FormGroup>
                            <Label className="d-flex align-items-center">
                                <Input type="checkbox"
                                checked={ticketForm.isDuration === 1} 
                                onChange={(e) => setTicketForm({...ticketForm,isDuration:e.target.checked ? 1 : 0})} 
                                className="me-2" />
                                Duration
                            </Label>
                        </FormGroup>
                        {ticketForm.isDuration === 1 ? (
                            <>
                            <Button color="primary mb-2" onClick={addDurations} className="me-2">Add More</Button>
                            <div className="d-flex flex-column">
                                {Array.isArray(durations) && durations.map((duration, index) => (
                                    <div key={index} className="d-flex align-items-center mb-2">
                                        <Input
                                            type="date"
                                            value={duration.fromDate}
                                            onChange={(e) => handleDurationChange(index, "fromDate", e.target.value)}
                                            className="me-2"
                                            required="true"
                                        />
                                        <Input
                                            type="date"
                                            value={duration.toDate}
                                            onChange={(e) => handleDurationChange(index, "toDate", e.target.value)}
                                            className="me-2"
                                            required="true"
                                        />
                                        {/* <Button color="primary" onClick={addDurations} className="me-2">+</Button> */}
                                        <Button color="danger" onClick={() => removeDurations(index)}>-</Button>
                                    </div>
                                ))}
                            </div>
                            </>
                        ):null}
                    </Col>
                    <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                                checked={ticketForm.isFixedDays === 1} 
                            onChange={(e) => setTicketForm({...ticketForm,isFixedDays:e.target.checked ? 1 : 0})} 
                            className="me-2" />
                            Fixed Days
                        </Label>
                    </FormGroup>
                    {ticketForm.isFixedDays === 1 ?(
                        <>
                        <div className="mb-3 d-flex align-items-center">
                            <Input type="number" placeholder="Add No of days" value={daysValue} onChange={(e) => setDaysValue(e.target.value)} className="me-2" />
                            <Button color="primary" onClick={addFixedDays} className="me-2">+</Button>
                        </div>
                            <div className="mb-3 d-flex align-items-center">
                                {Array.isArray(fixedDays) && fixedDays.map((d, i) => (
                                    <div className="text-dark" key={i}>
                                        <span className="badge bg-secondary me-1">
                                            {d.days} Days
                                            <span onClick={() => removeFixedDays(i)} style={{ cursor: "pointer" }} className="ms-2">
                                                &times;
                                            </span>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    ):null}
                    </Col>
                    <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                                checked={ticketForm.isRange === 1} 
                            onChange={(e) => setTicketForm({...ticketForm,isRange:e.target.checked ? 1 : 0})} 
                            className="me-2" />
                            Range
                        </Label>
                    </FormGroup>
                    {ticketForm.isRange === 1 ? (
                        <>
                        <div className="mb-3 d-flex align-items-center">
                            <Input type="number" 
                                placeholder="Min days" 
                                value={rangeValue.min} 
                                onChange={(e) =>
                                    setRangeValue((prev) => ({
                                        ...prev,
                                        min: e.target.value
                                    }))
                                }
                                className="me-2" 
                            />
                            <Input type="number" 
                                placeholder="Max days" 
                                value={rangeValue.max} 
                                onChange={(e) =>
                                    setRangeValue((prev) => ({
                                        ...prev,
                                        max: e.target.value
                                    }))
                                }
                                className="me-2"
                            />
                            <Button color="primary" onClick={addRangeDays} className="me-2">+</Button>
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                            {Array.isArray(rangeDays) && rangeDays.map((d, i) => (
                                <div className="text-dark" key={i}>
                                    <span className="badge bg-secondary me-1">
                                        {d.min}-{d.max} Days
                                        <span onClick={() => removeRangeDays(i)} style={{ cursor: "pointer" }} className="ms-2">
                                            &times;
                                        </span>
                                    </span>
                                </div>
                            ))}
                        </div>
                        </>
                        ):null}
                    </Col>
                    </>
                ):null}
            </Row> 
            {/* <Col md={12}>
                <FormGroup>
                    <Label className="d-flex align-items-center">
                    <h4 className="text-right text-black me-2">Enable Group Booking</h4>
                    <div className="form-check form-switch">
                        <input
                        className="form-check-input"
                        type="checkbox"
                        checked={ticketForm.groupBookingEnabled === 1}
                        onChange={(e) =>
                            setTicketForm({
                            ...ticketForm,
                            groupBookingEnabled: e.target.checked ? 1 : 0,
                            })
                        }
                        />
                    </div>
                    </Label>
                </FormGroup>
            </Col> */}
            <AdditionalFormFields addFormType={'generalForm'} placeId={placeId}/>
            {/* <Row>
                <Col md={12}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <h4 className="text-right text-black me-2">Enable Group Booking</h4>
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" 
                                checked={ticketForm.groupBookingEnabled === 1} 
                                onChange={(e) => setTicketForm({...ticketForm,groupBookingEnabled:e.target.checked ? 1 : 0})}
                                 />
                            </div>
                            
                        </Label>
                            <Row>
                                <Col md={12} className="mt-3">
                                    <FormGroup>
                                        <Label className="d-flex align-items-center">
                                        <h4 className="text-right text-black me-2">  Additional Fields</h4>
                                        <div className="form-check form-switch">
                                            <Input type="checkbox"
                                                checked={ticketForm.is_additional_fields === 1}
                                                onChange={(e) => {
                                                    setTicketForm(prev => ({
                                                        ...prev,
                                                        is_additional_fields: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="me-2" />
                                        </div>
                                        </Label>
                                    </FormGroup>
                                </Col>
                                {ticketForm.is_additional_fields === 1 && (
                                    <>
                                        <Col md={4} className="mt-3 mb-3">
                                            <Input type="select" name="add_field_for"
                                                value={addFormType}
                                                onChange={(e) => setAddFormType(e.target.value)}
                                            >
                                                <option  value="">Select Form</option>
                                                <option  value="generalForm">General Form</option>
                                                <option  value="groupBooking">Group Booking Form</option>
                                                <option  value="vehicle">Vehicle Form</option>
                                                <option  value="zone">Zone Form</option>
                                            </Input>
                                            <span className="d-block text-danger">{errors?.add_field_for}</span>
                                        </Col>
                                        <Col md={8} className="mb-3"></Col>
                                        {addFormType !="" && (
                                            <>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label className="d-flex align-items-center">
                                                            <Input type="checkbox"
                                                                checked={ticketForm.is_group_booking_category === 1}
                                                                onChange={(e) => {
                                                                    setTicketForm(prev => ({
                                                                        ...prev,
                                                                        is_group_booking_category: e.target.checked ? 1 : 0
                                                                    }));
                                                                }}
                                                                className="me-2" />
                                                            Booking Category
                                                        </Label>
                                                    </FormGroup>
                                                    {ticketForm.is_group_booking_category === 1 && (
                                                        <>
                                                            {bookingCategory?.map((field, i) => (
                                                                <div className="d-flex align-items-center mb-3" key={i}>
                                                                    <Input type="text"
                                                                        placeholder="Field Name"
                                                                        value={field.name}
                                                                        onChange={(e) => handleBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                                                        className="me-2" />
                                                                    <Button className="ms-1" color="primary" onClick={addBookingCategoryInput}>
                                                                        +
                                                                    </Button>
                                                                    <Button className="ms-1" color="danger" onClick={() => removeBookingCategoryInput(i)}>
                                                                        -
                                                                    </Button>
                                                                </div>
                                                            ))}
                                                            <Button className="bg-success text-white" size="sm" onClick={handleBookingCategorySubmit}>
                                                                Add Booking Category
                                                            </Button>
                                                        </>
                                                    )}
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label className="d-flex align-items-center">
                                                            <Input type="checkbox"
                                                                checked={ticketForm.is_group_booking_sub_category === 1}
                                                                onChange={(e) => {
                                                                    setTicketForm(prev => ({
                                                                        ...prev,
                                                                        is_group_booking_sub_category: e.target.checked ? 1 : 0
                                                                    }));
                                                                }}
                                                                className="me-2" />
                                                            Booking Sub Category
                                                        </Label>
                                                    </FormGroup>
                                                    {ticketForm.is_group_booking_sub_category === 1 && ticketForm.is_group_booking_category === 1 && (
                                                        <>
                                                            <div className="mb-3">
                                                                <Input type="select" name="place_id"
                                                                    value={ticketForm.booking_category_id}
                                                                    onChange={(e) =>{
                                                                        setTicketForm((prev) => ({
                                                                            ...prev,
                                                                            booking_category_id: e.target.value,
                                                                        }))
                                                                        dispatch(getBookingSubCategories(auth.token,placeId,e.target.value))
                                                                    }}
                                                                >
                                                                    <option value="">Select Booking Category</option>
                                                                    {bookingCategories?.map((item) => (
                                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </Input>
                                                            </div>
                                                            {subBookingCategory?.map((field, i) => (
                                                                <div className="d-flex align-items-center mb-3" key={i}>
                                                                    <Input type="text"
                                                                        placeholder="Field Name"
                                                                        value={field.name}
                                                                        onChange={(e) => handleSubBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                                                        className="me-2" />
                                                                    <Button className="ms-1" color="primary" onClick={addSubBookingCategoryInput}>
                                                                        +
                                                                    </Button>
                                                                    <Button className="ms-1" color="danger" onClick={() => removeSubBookingCategoryInput(i)}>
                                                                        -
                                                                    </Button>
                                                                </div>
                                                            ))}
                                                            <Button className="bg-success text-white" size="sm" onClick={handleSubBookingCategorySubmit}>
                                                                Add Booking Sub Category
                                                            </Button>
                                                        </>
                                                    )}
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label className="d-flex align-items-center">
                                                            <Input type="checkbox"
                                                                checked={ticketForm.is_group_booking_sub_sub_category === 1}
                                                                onChange={(e) => {
                                                                    setTicketForm(prev => ({
                                                                        ...prev,
                                                                        is_group_booking_sub_sub_category: e.target.checked ? 1 : 0
                                                                    }));
                                                                }}
                                                                className="me-2" />
                                                            Booking Sub Sub Category
                                                        </Label>
                                                    </FormGroup>
                                                    {ticketForm.is_group_booking_sub_sub_category === 1 && ticketForm.is_group_booking_sub_category === 1 && ticketForm.is_group_booking_category === 1 && (
                                                        <>
                                                            <div className="mb-3">
                                                                <Input type="select" name="place_id"
                                                                    value={ticketForm.booking_sub_category_id}
                                                                    onChange={(e) =>{
                                                                        setTicketForm((prev) => ({
                                                                            ...prev,
                                                                            booking_sub_category_id: e.target.value,
                                                                        }));
                                                                        dispatch(getBookingSubSubCategories(auth.token,placeId,ticketForm.booking_category_id,e.target.value))
                                                                    }}
                                                                >
                                                                    <option value="">Select Booking Sub Category</option>
                                                                    {bookingSubCategories?.map((item) => (
                                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </Input>
                                                            </div> 
                                                            {subSubBookingCategoryInput?.map((field, i) => (
                                                                <div className="d-flex align-items-center mb-3" key={i}>
                                                                    <Input type="text"
                                                                        placeholder="Field Name"
                                                                        value={field.name}
                                                                        onChange={(e) => handleSubSubBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                                                        className="me-2" />
                                                                    <Button className="ms-1" color="primary" onClick={addSubSubBookingCategory}>
                                                                        +
                                                                    </Button>
                                                                    <Button className="ms-1" color="danger" onClick={() => removeSubSubBookingCategory(i)}>
                                                                        -
                                                                    </Button>
                                                                </div>
                                                            ))}
                                                            <Button className="bg-success text-white" size="sm" onClick={handleSubSubBookingCategorySubmit}>
                                                                Add Booking Sub Sub Category
                                                            </Button>
                                                        </>
                                                    )}
                                                </Col>
                                            </>
                                        )}
                                    </>
                                )}
                                <Col md={12} className="mt-3">
                                    {(ticketForm.is_additional_fields === 1 && addFormType !="") && (
                                        <>
                                        <Row>
                                            <Col md={3} className="mt-3">
                                                <div className="mb-3">
                                                    <Input type="select" name="booking_category_id"
                                                        value={addFields.booking_category_id}
                                                        onChange={handleAddFieldChange}
                                                    >
                                                        <option value="">Select Booking Category</option>
                                                        {bookingCategories?.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.name}</option>
                                                        ))}
                                                    </Input>
                                                    <span className="d-block text-danger">{errors?.booking_category_id}</span>
                                                </div>
                                            </Col>
                                            <Col md={3} className="mt-3">
                                                <div className="mb-3">
                                                    <Input type="select" name="booking_sub_category_id"
                                                        value={addFields.booking_sub_category_id}
                                                        onChange={handleAddFieldChange}
                                                    >
                                                        <option value="">Select Booking Sub Category</option>
                                                        {bookingSubCategories?.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.name}</option>
                                                        ))}
                                                    </Input>
                                                    <span className="d-block text-danger">{errors?.booking_sub_category_id}</span>
                                                </div> 
                                            </Col>
                                            <Col md={3} className="mt-3">
                                                <Input type="text"
                                                    placeholder="Field Name"
                                                    name="field_name"
                                                    value={addFields.field_name}
                                                    onChange={handleAddFieldChange}
                                                    className="me-2" />
                                                <span className="d-block text-danger">{errors?.field_name}</span>
                                            </Col>
                                            <Col md={3} className="mt-3">
                                                <Input type="select" name="field_type"
                                                    value={addFields.field_type}
                                                    onChange={handleAddFieldChange}
                                                >
                                                    <option  value="">Select Field Type</option>
                                                    <option  value="text">Text Field</option>
                                                    <option  value="textarea">Textarea Field</option>
                                                    <option  value="checkbox">Checkbox Field</option>
                                                    <option  value="document">Attach Document</option>
                                                </Input>
                                                <span className="d-block text-danger">{errors?.field_type}</span>
                                            </Col>
                                            {addFields.field_type === "document" && (
                                                <>
                                                    <Col md={3} className="mt-3">
                                                        <Input type="file"
                                                            name="file"
                                                            onChange={handleAddFieldChange}
                                                            className="me-2" />
                                                    </Col>
                                                    <Col md={3} className="mt-3">
                                                        <Input type="text"
                                                        placeholder="Link"
                                                        name="link"
                                                        value={addFields.link}
                                                        onChange={handleAddFieldChange}
                                                        className="me-2" />
                                                    </Col>
                                                    <Col md={3} className="mt-3">
                                                        <FormGroup>
                                                            <Label className="d-flex align-items-center">
                                                                <Input type="checkbox"
                                                                    checked={addFields.is_upload_doc == 1}
                                                                    onChange={(e) => {
                                                                        setAddFields(prev => ({
                                                                            ...prev,
                                                                            is_upload_doc: e.target.checked ? 1 : 0
                                                                        }));
                                                                    }}
                                                                    className="me-2" />
                                                                Upload Document
                                                            </Label>
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            )}
                                            <Col md={4} className="mt-3">
                                                <Button className="ms-1" disabled={(placeId != 0) ? false:true} color="primary" 
                                                    onClick={addAllAdditionalField}
                                                >
                                                    Add Additional Fields
                                                </Button>
                                            </Col>
                                            
                                        </Row>
                                        </>
                                    )}
                                </Col>
                                <Col md={12} className="mt-3">
                                    {ticketFormAdditionalFields.length > 0 && (
                                        <Table bordered>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Booking Category</th>
                                                    <th>Booking Sub Category</th>
                                                    <th>Field Name</th>
                                                    <th>Field Type</th>
                                                    <th>File</th>
                                                    <th>Link</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ticketFormAdditionalFields.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.bookingCategory?.name}</td>
                                                        <td>{item?.bookingSubCategory?.name}</td>
                                                        <td>{item.field_name}</td>
                                                        <td>{item.field_type}</td>
                                                        <td>{item.file ? item.file.name : "N/A"}</td>
                                                        <td>{item.link ?? "N/A"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Col>
                            </Row> 
                    </FormGroup>
                </Col>
            </Row> */}
            <Button color="success" onClick={handleSubmit} className="mt-3 w-100">
                Submit
            </Button>
        </div>
    );
};

export default TicketForm;
